var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiconText = function SvgMiconText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M27 22.142V9.862a4 4 0 1 0-4.86-4.86H9.86A4 4 0 1 0 5 9.862v12.28a4 4 0 1 0 4.86 4.86h12.28a4 4 0 1 0 4.86-4.86m-1-18.14a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-22 2a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2 22A2 2 0 1 1 6 24a2 2 0 0 1 0 4m16.14-3H9.86A4 4 0 0 0 7 22.142V9.862a4 4 0 0 0 2.86-2.86h12.28A4 4 0 0 0 25 9.862v12.28a4 4 0 0 0-2.86 2.86m3.86 3A2 2 0 1 1 26 24a2 2 0 0 1 0 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M21 11H11v2h4v9h2v-9h4z"
  })));
};
export default SvgMiconText;